module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Thêm mới bài viết",
      "breadcrumbs": [{
        title: 'Quản lý bài viết',
        route: {
          name: 'blog'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-all"
  }, [_c('el-form', {
    ref: "createBlogForm",
    attrs: {
      "model": _vm.localBlog,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitBlog('createBlogForm')
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tiêu đề",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tiêu đề"
    },
    model: {
      value: (_vm.localBlog.title),
      callback: function($$v) {
        _vm.$set(_vm.localBlog, "title", $$v)
      },
      expression: "localBlog.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nội dung viết tắt",
      "prop": "teaser"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Nội dung viết tắt"
    },
    model: {
      value: (_vm.localBlog.teaser),
      callback: function($$v) {
        _vm.$set(_vm.localBlog, "teaser", $$v)
      },
      expression: "localBlog.teaser"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Ảnh bài viết"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.uploadImageUrl,
      "headers": _vm.uploadHeader,
      "show-file-list": false,
      "on-success": _vm.handleImageUpload
    }
  }, [(_vm.image.path) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.image.path
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Chọn loại bài viết",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn loại bài viết"
    },
    on: {
      "change": _vm.getCategories
    },
    model: {
      value: (_vm.localBlog.type),
      callback: function($$v) {
        _vm.$set(_vm.localBlog, "type", $$v)
      },
      expression: "localBlog.type"
    }
  }, _vm._l((_vm.blogHelpers.types), function(type, key, index) {
    return (_vm.blogHelpers.types) ? _c('el-option', {
      key: index,
      attrs: {
        "label": type,
        "value": key
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Chọn danh mục",
      "prop": "category_id"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn danh mục"
    },
    model: {
      value: (_vm.localBlog.category_id),
      callback: function($$v) {
        _vm.$set(_vm.localBlog, "category_id", $$v)
      },
      expression: "localBlog.category_id"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.name,
        "value": category.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Trạng thái",
      "prop": "active"
    }
  }, _vm._l((_vm.blogHelpers.statuses), function(status, index) {
    return _c('el-radio', {
      key: index,
      staticClass: "radio",
      attrs: {
        "label": index
      },
      model: {
        value: (_vm.localBlog.active),
        callback: function($$v) {
          _vm.$set(_vm.localBlog, "active", $$v)
        },
        expression: "localBlog.active"
      }
    }, [_vm._v(_vm._s(status))])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Hot"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "name": "hot"
    },
    model: {
      value: (_vm.localBlog.hot),
      callback: function($$v) {
        _vm.$set(_vm.localBlog, "hot", $$v)
      },
      expression: "localBlog.hot"
    }
  }, [_vm._v("Hot")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Hiển thị trang shop"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "name": "show_on_shop"
    },
    model: {
      value: (_vm.localBlog.show_on_shop),
      callback: function($$v) {
        _vm.$set(_vm.localBlog, "show_on_shop", $$v)
      },
      expression: "localBlog.show_on_shop"
    }
  }, [_vm._v("Hiển thị trang shop")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tags",
      "prop": "tags"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "Nhập tag...",
      "remote-method": _vm.selectTag,
      "loading": _vm.fetchTag
    },
    on: {
      "change": _vm.selectSuggettionTag
    },
    model: {
      value: (_vm.suggettionTag),
      callback: function($$v) {
        _vm.suggettionTag = $$v
      },
      expression: "suggettionTag"
    }
  }, _vm._l((_vm.listTags), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item,
        "label": item.tag
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n           \n        ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Hiển thị trang landing"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "name": "show_on_shop"
    },
    model: {
      value: (_vm.localBlog.show_on_landing),
      callback: function($$v) {
        _vm.$set(_vm.localBlog, "show_on_landing", $$v)
      },
      expression: "localBlog.show_on_landing"
    }
  }, [_vm._v("Hiển thị trang landing")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Danh sách tags"
    }
  }, [_vm._l((_vm.selectedTags), function(tag) {
    return _c('el-tag', {
      key: tag.id,
      staticClass: "margin-sm-right",
      attrs: {
        "closable": true,
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.removeTag(tag)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag.tag) + "\n            ")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ New Tag")])], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.imageContent.path) ? _c('p', [_c('span', [_vm._v("Đường dẫn: ")]), _vm._v(" "), _c('span', {
    staticClass: "text-blue"
  }, [_vm._v(_vm._s(_vm.imageContent.path))])]) : _vm._e()])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    staticClass: "blog-content",
    attrs: {
      "label": "Nội dung bài viết",
      "prop": "content"
    }
  }, [_c('el-input', {
    attrs: {
      "name": "content",
      "type": "textarea",
      "autosize": "",
      "placeholder": "Nội dung bài viết"
    },
    model: {
      value: (_vm.localBlog.content),
      callback: function($$v) {
        _vm.$set(_vm.localBlog, "content", $$v)
      },
      expression: "localBlog.content"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Upload ảnh nội dung bài viết"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.uploadImageUrl,
      "headers": _vm.uploadHeader,
      "show-file-list": false,
      "on-success": _vm.handleImageContentUpload
    }
  }, [(_vm.imageContent.path) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageContent.path
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6d4b6f87"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/EditBlog.vue
// module id = 716
// module chunks = 1